import { useQuery } from "react-query";
import { IOnboardDingPlaylistResponseField } from "~/lib/types/onboarding.videos.type";
import { getOnboardingVideos } from "../onboarding.videos.service";


const API_ONBROADING_QUERY_KEY = {
    GET_ALL_VIDEOS_SETEL: "GET_ALL_VIDEOS_SETEL",
  } as const;

export const useGetAllVideosSetel = (enableFetchVideo: boolean) =>
  useQuery(
    [API_ONBROADING_QUERY_KEY.GET_ALL_VIDEOS_SETEL],
    () =>
    getOnboardingVideos().then((res: IOnboardDingPlaylistResponseField[]) => res.reverse()),
    {
      enabled: enableFetchVideo,
    }
  );
